import axios from "axios";

export const GET_API_DATA = async (data) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}settings/api`)
    .then((res) => {
      return res.data;
    });
};